import React, { useEffect, useState } from "react";
import HeaderRoutes from "../../components/HeaderRoutes/HeaderRoutes";
import { Grid , Box , Paper, Typography , Button , TextField , CircularProgress , InputLabel} from "@mui/material";
import { useTheme,styled } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import axios from 'axios';
import config from '../../config/config';
import Toast from '../../config/Toast';
import Multiselect from 'multiselect-react-dropdown';

const CreateVariables = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [type, setType] = useState('');
    const [variableOptions, setVariableOptions] = useState([]);
    const [selectedVariables, setSelectedVariables] = useState([]);
    const [department , setDepartment] = useState([])
    const [selectedDepartment , setSelectedDepartment] = useState([])

    const VariableList = async () => {
        const data = {
            search : '',
        };

        const path = `${config.authServiceUrl}variables/list`;
        const token = localStorage.getItem("tokenId");
    
        try {
        const response = await axios.post(path, data, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        }); 
            const rawList = response?.data?.data || [];
            const formattedList = rawList.map((item) => ({
                label: item.variable_name,
                value: item.id,
            }));
            setVariableOptions(formattedList);
        } catch (error) {
            const apiError = error.response?.data?.message || "An error occurred.";
            setMessage(apiError);
            setType('error');
            setSnackbarOpen(true);
        }
    };

    useEffect(()=>{
        VariableList()
    } , [])

    const fetchListData = async () => {
        const dataLive = { type: "LIVE" };
        const dataTest = { type: "TEST" };
        const path = `${config.authServiceUrl}database/list`;
        const token = localStorage.getItem("tokenId");
      
        try {
          const responseLive = await axios.post(path, dataLive, {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });
      
          const responseTest = await axios.post(path, dataTest, {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });
      
          const idsLive = responseLive.data.data.map((item) => ({
            id: item.id,
            department_name: item.department_name,
          }));
      
          const idsTest = responseTest.data.data.map((item) => ({
            id: item.id,
            department_name: item.department_name,
          }));
      
          const combinedIds = Array.from(new Map(
            [...idsLive, ...idsTest].map((item) => [item.id, item])
          ).values());

          const formattedList = combinedIds.map((item) => ({
                label: `${item.id} - ${item.department_name}`,
                value: item.id,
            }));
      
          setDepartment(formattedList);
        } catch (error) {
          console.error("Error:", error.response?.data?.message || "Failed to fetch departments");
        }
    };

    useEffect(()=>{
        fetchListData()
    }, [])

    const handleSubmit = async () => {
        const data = {
            variable_name : selectedVariables,
            dept_name : selectedDepartment,
        };
    
        const path = `${config.authServiceUrl}variables/copy-to-dept`;
        const token = localStorage.getItem("tokenId");
    
        try {
        const response = await axios.post(path, data, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        }); 
            setSnackbarOpen(true);
            setMessage('Send Successfully');
            setType('success');
            setSelectedDepartment([]);
            setSelectedVariables([]);
        } catch (error) {
            const apiError = error.response?.data?.message || "An error occurred.";
            setMessage(apiError);
            setType('error');
            setSnackbarOpen(true);
        }
    };

    const handleCloseSnackbar = () => {
      setSnackbarOpen(false);
    };

     
  return (
    <>
      <HeaderRoutes />
        <Paper sx={{ height: 'fit-content', margin: isMobile ? '16px' : '16px', padding: '20px' }}>
          <Typography
            style={{
              fontFamily: 'Karla',
              fontStyle: 'normal',
              fontSize: '20px',
              lineHeight: '150%',
              color: '#000000',
              fontWeight: 500,
            }}
          >
            Copy Variables
          </Typography>

            <Box className = 'mt-5 px-3'>
                <Grid container spacing={2}>
                    <Grid xs={6}>
                        <InputLabel
                            shrink
                                htmlFor="variable-multiselect"
                                sx={{ fontSize: '22px', color: '#000' }}
                            >
                            Select Variables
                        </InputLabel>
                        <Multiselect
                            displayValue="label"
                            options={variableOptions}
                            showCheckbox
                            showArrow
                            style={{
                                chips: {
                                    background: 'rgb(191, 29, 45)',
                                    color: '#fff',          
                                    borderRadius: '30px',
                                },
                                option: {
                                    backgroundColor: '#ffffff',
                                    color: '#000',
                                },
                            }}
                            customCloseIcon={
                                <img
                                    src="/images/cross.png"
                                    alt="close"
                                    width="16px"
                                    height="16px"
                                    style={{ marginLeft: '8px', cursor: 'pointer' }}
                                />
                            }
                            placeholder="Select Variables"
                            selectedValues={variableOptions.filter(option => selectedVariables.includes(option.value))}
                            onSelect={(selectedList) =>
                                setSelectedVariables(selectedList.map((item) => item.value))
                            }
                            onRemove={(selectedList) =>
                                setSelectedVariables(selectedList.map((item) => item.value))
                            }
                            customInputRenderer={(inputProps) => (
                                <TextField
                                    {...inputProps}
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        sx={{
                                        "& .MuiInputBase-root": {
                                            height: "56px",
                                            fontSize: "14px",
                                            display: "flex",
                                            alignItems: "center",
                                        },
                                    }}
                                />
                            )}
                        />
                    </Grid>

                    <Grid xs={6} className="px-2">
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <InputLabel
                                shrink
                                htmlFor="variable-multiselect"
                                sx={{ fontSize: '22px', color: '#000' }}
                                >
                                Select Departments
                            </InputLabel>
                            <Button
                                variant="contained"
                                size="small"
                                onClick={() => {
                                    const allSelected = department.length === selectedDepartment.length;
                                    if (allSelected) {
                                        setSelectedDepartment([]);
                                    } else {
                                        setSelectedDepartment(department.map(dep => dep.value));
                                    }
                                }}
                                sx={{ textTransform: 'none', fontSize: '12px', borderRadius:'10px' , color: '#bf1d2d', minWidth: 'auto' , backgroundColor:'#E62719' , color:'#ffffff' }}
                            >
                                {department.length === selectedDepartment.length ? 'Unselect All' : 'Select All'}
                            </Button>
                        </Box>
                        <Multiselect
                            displayValue="label"
                            options={department}
                            showCheckbox
                            showArrow
                            style={{
                                chips: {
                                    background: 'rgb(191, 29, 45)',
                                    color: '#fff',          
                                    borderRadius: '30px',
                                },
                                option: {
                                    backgroundColor: '#ffffff',
                                    color: '#000',
                                },
                            }}
                            customCloseIcon={
                                <img
                                    src="/images/cross.png"
                                    alt="close"
                                    width="16px"
                                    height="16px"
                                    style={{ marginLeft: '8px', cursor: 'pointer' }}
                                />
                            }
                            placeholder="Select Department"
                            selectedValues={department.filter(option => selectedDepartment.includes(option.value))}
                            onSelect={(selectedList) =>
                                setSelectedDepartment(selectedList.map((item) => item.value))
                            }
                            onRemove={(selectedList) =>
                                setSelectedDepartment(selectedList.map((item) => item.value))
                            }
                            customInputRenderer={(inputProps) => (
                                <TextField
                                    {...inputProps}
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        sx={{
                                        "& .MuiInputBase-root": {
                                            height: "56px",
                                            fontSize: "14px",
                                            display: "flex",
                                            alignItems: "center",
                                        },
                                    }}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
            </Box>

            <Box className='mt-4'>
                <Button
                    variant="contained"
                    color="primary"
                    disabled = {selectedVariables.length == 0 || selectedDepartment.length == 0}
                    sx={{backgroundColor: '#BF1D2D', fontSize: '16px', fontWeight: '500', padding:'20px' ,  height: '38px' }}
                    onClick={handleSubmit}
                >
                    Submit
                </Button>
            </Box>
        </Paper>

        <Toast
          snackbarOpen={snackbarOpen}
          handleCloseSnackbar={handleCloseSnackbar}
          message={message}
          type={type}
        />
      </>
  );
};

export default CreateVariables;





